<template>
  
  
    <vx-card title="Send Email">

      <div>
        <!-- {{emailRecipent}} -->
        <!-- {{companiesGroups}} -->
        <div class="mb-3">
          <p class="labels">Email recipients *</p>
          <ul>
            <li>
              <vs-radio v-model="emailData.form.emailRecipents" vs-name="radios1" vs-value="allCompanies">All Companies</vs-radio>
            </li>
            <li>
              <vs-radio v-model="emailData.form.emailRecipents" vs-name="radios1" vs-value="specificCompaniesGroup">Choose a companies Group</vs-radio>
            </li>
            <li>
              <vs-radio v-model="emailData.form.emailRecipents" vs-name="radios1" vs-value="specificCompanies">Choose specific companies</vs-radio>
            </li>
            <!-- <li>
              <vs-radio v-model="emailData.form.emailRecipents" vs-name="radios1" vs-value="manual">Manually add emails</vs-radio>
            </li> -->

          </ul>

          <div style="margin-top:10px;" v-if="emailData.form.emailRecipents == 'specificCompaniesGroup'">
              <p class="labels">Choose the group to send the email to *</p>
              <vs-select placeholder="Select Group" v-model="emailData.form.selectedGroup" >
                <vs-select-item  v-for="(group, i) in companiesGroups" :key="i" :value="group.id" :text="group.name" />
              </vs-select>
          </div>

          <div v-if="emailData.form.emailRecipents == 'specificCompanies'">
            <p  class="labels" style="margin-bottom:5px;margin-top:5px;">Choose the companies that the email will be sent to *</p>
            <ul style="display:flex; justify-content: flex-start; flex-wrap: wrap;">
              <li style="width: 30%; flex-grow: 1; margin-right:2%; margin-top:5px;margin-bottom:5px; color: #4c96d7; " v-for="(company, index) in companies" :key="index">
                  <vs-checkbox v-model="emailData.form.selectedCompanies" :vs-value="company.id" >{{ company.name }} - <span style="">{{ company.email }}</span> </vs-checkbox>
              </li>
            </ul>
          </div>

          <!-- <div style="margin-top:10px;" v-if="emailData.form.emailRecipents == 'manual'">
              <p class="labels">Enter the email addresses you want to send to, each separated by a comma (,)</p>
              <div style="display:flex; margin-bottom: 10px;">
                <vs-input style="width:250px" placeholder="mohamed@gmail.com" v-model="email"/>
                <vs-button style="margin-left: 10px; font-size: 12px; padding: 0px 15px;" @click="addEmailToList()">Add Email</vs-button>
              </div>
              <div v-for="(email, index) in emailData.form.selectedEmails" :key="index">
                <div style="display:flex; align-items: flex-end;">
                  <div style="width:305px;">
                    <p class="show-names" >{{email}}</p>
                  </div>
                  <vs-button style="margin-left: 10px; height: 23px !important;" color="danger" icon="remove" @click="removeEmailFromList(email)"></vs-button>
                </div>
              </div>
          </div> -->

          <div v-if="this.emailTemplates.length>0" style="margin-top:10px;">
            <p class="labels">Choose your preferred Email Template *</p>
            <ul>
              <li v-for="(emailTemplate) in this.emailTemplates" :key="emailTemplate.id" style="flex-grow:1">
                <vs-radio v-model="emailData.form.emailTemplate" vs-name="radios2" :vs-value="emailTemplate.id">{{emailTemplate.name}}</vs-radio>
              </li>
            </ul>
          </div>
          
        </div>
        <div class="mb-3">
          <p class="labels">Subject *</p>
          <vs-input style="width:500px;" placeholder="Enter the subject of the email" v-model="emailData.form.subject"/>
        </div> 
        
        
        <div v-if="emailData.form.emailTemplate == 2" class="mb-3">        
          <p  class="labels" >Upload Image of Template *</p>
          <input style="width: 300px;" type="file" accept="image/*" @change="uploadImageTemplate()" ref="imageTemplate"/>
        </div>

        <div v-if="emailData.form.emailTemplate != 2" class="mb-3">        
           <p  class="labels" >Body *</p>
          <vs-textarea  height="400"  v-model="emailData.form.body"/>
        </div>

        <div class="mb-3">
          <p  class="labels" style="margin-bottom:5px;">Upload attachments (optional)</p>
          <input style="width: 300px;" multiple type="file" @change="uploadFiles()" ref="file"/>
          <div style="margin-top:5px;">
            <div v-for="(file,index) in emailData.form.attachments" :key="index">
              <p class="show-names">{{(index+1)}} . {{file.name}}</p>
            </div>
          </div>
        </div>
        <vs-divider/>        


        <div id="email-view-container" style="display:none;">
        </div>

        <div class="mt-5" style="display:flex; justify-content:flex-end;">
          <div style="margin-right: 10px;">
            <vs-button class="preview-button" @click="viewEmail" :disabled="isPreviewDisabled">Preview</vs-button>
          </div>
          <div>
            <vs-button color="primary" type="filled" @click="sendEmail" :disabled="isPreviewDisabled">Send</vs-button>
          </div>
        </div>

      </div>

  
    </vx-card>
  
  </template>
  
  <script>
    import {mapActions, mapGetters} from "vuex";
    import $ from "jquery";

    export default {
      name: "SendNotification",
      components: {
      },
      data() {
        return {
          backgroundLoading:'primary',
          colorLoading:'#fff',
          email : null,
          emailData: {
            form: {
              subject : null,
              body : null,
              selectedEmails: [],
              selectedGroup : null,
              selectedCompanies : [],
              emailRecipents : "allCompanies",
              attachments : [],
              emailTemplate : 1,
              templateImage : []
            },
            formData : new FormData(),
            url: 'admin/send-notification',
            // storeName: 'companiesGroups',
            hasFormData: true,
          }
        }
      },
      async created() {
        this.$vs.loading({ text: 'Loading Companies...' })
        await this.loadCompanies({
            storeName: 'companies',
            url: `admin/companies`,
            commitUrl: 'companies/SET_COMPANIES',
        })
        this.$vs.loading.close()

        this.$vs.loading({ text: 'Loading Companies Groups...' })
        await this.loadCompaniesGroups({
            storeName: 'companiesGroups',
            url: `admin/companiesGroups`,
            commitUrl: 'companiesGroups/SET_COMPANIES_GROUP',
        })
        this.$vs.loading.close()

        this.$vs.loading({ text: 'Loading Email Templates...' })
        await this.loadEmailTemplates({
            storeName: 'emailTemplates',
            url: `admin/emailtemplates`,
            commitUrl: 'emailTemplates/SET_EMAIL_TEMPLATES',
        })
        console.log(this.emailTemplates)
        this.$vs.loading.close()
      },
      mounted: function() {
        $(function() {
          console.log("MOUNTED")
        })
        
      }, 
      computed: {
        ...mapGetters({
          companies: 'companies/companiesList',
          companiesGroups: 'companiesGroups/companiesGroupsList',
          emailTemplates: 'emailTemplates/emailTemplatesList'
        }),
        isPreviewDisabled(){
          if(!this.emailData.form.subject){
            return true;
          }
          if(this.emailData.form.emailTemplate == 2){
              if(this.emailData.form.templateImage.length == 0){
                return true;
              }
          }else{
              if(!this.emailData.form.body){
                return true;
              }
          }
          return false;
        },

      },
    watch: {
    },
    methods: {
        ...mapActions({
          loadCompanies: 'get',
          loadCompaniesGroups: 'get',
          loadEmailTemplates : 'get',
          sendEmails: 'add',
          viewEmailFinalTemplate: 'add'
        }),

        uploadFiles() {
          this.emailData.form.attachments = []
          for(var i = 0; i < this.$refs.file.files.length; i++){
              let file = this.$refs.file.files[i];
              this.emailData.form.attachments.push(file)
              // formData.append('files[' + i + ']', file);
          }
          console.log(this.emailData.form.attachments)
          // console.log(this.emailData.form.attachments)
        },
        uploadImageTemplate(){
          // console.log(this.$refs.imageTemplate.files[0])
          this.emailData.form.templateImage = []
          this.emailData.form.templateImage.push(this.$refs.imageTemplate.files[0] )
          console.log(this.emailData.form.templateImage)
        },
        addEmailToList(){
          if(this.email){
            let email = this.email.replace(/\s/g, '');
            if (! /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)){
              alert('Invalid Email...Please enter a correct email format')
              return ;
            }
            this.emailData.form.selectedEmails.push(email)
          }
          
          this.email = null
        },
        removeEmailFromList(emailToDelete){
          this.emailData.form.selectedEmails = this.emailData.form.selectedEmails.filter(function(email) {
            return email !== emailToDelete
          })
        },      
        viewEmail(){
          let formDataTemp = new FormData();
          formDataTemp.append('emailTemplate', JSON.stringify(this.emailData.form.emailTemplate));
          formDataTemp.append('body', JSON.stringify(this.emailData.form.body));

          if(this.emailData.form.templateImage.length > 0){
              formDataTemp.append('templateImage[0]' , this.emailData.form.templateImage[0]);
            }else{
              formDataTemp.append('templateImage', [])
            }
          this.$vs.loading({ text: 'Loading Email Preview...' })
          this.viewEmailFinalTemplate({
              // form: {
              //   emailTemplate: vm.emailData.form.emailTemplate,
              //   body :vm.emailData.form.body,
              //   templateImage: vm.emailData.form.templateImage 
              // },
              formData: formDataTemp,
              url: 'admin/get-final-email-view',
              hasFormData: true,
          }).then((res)=>{
            $(function(){
              $("#email-view-container").html(res.data);
              //Make font size of email retrieved template bigger by 2px because size in dashboard appears smaller than actual size due to vuesax/tailwand/loadedscrips(unknown issue)
              let fontSize = parseInt($('.email-wrapper').css("font-size").split('px')[0]);
              fontSize = fontSize+2;
              $('.email-wrapper').css("font-size", `${fontSize}px`)
              $("#email-view-container").css("display", "block");

              console.log(res.data)
            })
          }).catch((e)=>{
            console.log(e)
          }).finally(()=>{
            this.emailData.formData = new FormData();
            this.$vs.loading.close()
          })
        } ,
        async sendEmail() {
          if(confirm("Are you sure ?")){
            const vm = this;
            if(this.emailData.form.emailRecipents == 'specificCompaniesGroup'){
              if(!this.emailData.form.selectedGroup){
                this.$vs.notify({color:'danger',title:'Error',text:'Please choose a group!'})
                return;
              }
            }else if(this.emailData.form.emailRecipents == 'specificCompanies'){
              if(this.emailData.form.selectedCompanies.length === 0){
                this.$vs.notify({color:'danger',title:'Error',text:'Please add atleast 1 email company!'})
                return;
              }
            }else if(this.emailData.form.emailRecipents == 'manual'){
              if(this.emailData.form.selectedEmails.length === 0){
                this.$vs.notify({color:'danger',title:'Error',text:'Please add atleast 1 email recipient!'})
                return;
              }
            }

            if(!this.emailData.form.subject){
              this.$vs.notify({color:'danger',title:'Error',text:'Please add the subject of the email!'})
              return;
            }

            if(this.emailData.form.emailTemplate == 2){
              if(!this.emailData.form.templateImage){
                this.$vs.notify({color:'danger',title:'Error',text:'Please upload an image for the Image Template'})
                return;
              }
            }else{
                if(!this.emailData.form.body){
                  this.$vs.notify({color:'danger',title:'Error',text:'Please add the body of the email!'})
                  return;
                }
            }


            Object.entries(this.emailData.form).forEach(([key, value]) => {
              if(key != 'attachments'){
                if(key == 'selectedEmails' || key == 'selectedCompanies'){
                this.emailData.formData.append(key, JSON.stringify(value));
              }
                else{
                  this.emailData.formData.append(key, value);
                }
              }
            });


            if(this.emailData.form.templateImage.length > 0){
              this.emailData.formData.append('templateImage[0]' , this.emailData.form.templateImage[0]);
            }else{
              this.emailData.formData.append('templateImage', [])
            }

            if(this.emailData.form.attachments.length > 0){
              this.emailData.form.attachments.forEach((file, i)=>{
                this.emailData.formData.append('attachments['+i+']' , file);
              })
            }else{
              this.emailData.formData.append('attachments', [])
            }
            
            this.$vs.loading({ text: 'Sending Emails' })
            this.sendEmails(this.emailData).then((res)=>{
              this.successNotify(res.data.message)
            }).catch((e)=>{
              console.log(e.message)
              this.errorNotify(e)
            }).finally(()=>{
              this.emailData.formData = new FormData();
              this.$vs.loading.close()
            })

          }
        },
        errorNotify(msg){
          this.$vs.notify({color:'danger',title:'Error',text:msg})
        },
        successNotify(msg){
          this.$vs.notify({color:'success',title:'Success',text:msg})
        },
      },
    }
  </script>
  
  <style scoped>

  .preview-button{
    background: rgb(255, 255, 255) !important;
    border: 2px solid rgb(25, 160, 255);
    font-weight: 600;
    font-size: 14px;
    color: #19a0ff;
  }
  .preview-button:disabled{
    background: #dcdcdc !important;
    color: black;
    font-weight: 300;
    border: 2px solid white;
  }
  #email-view-container{
    margin-top: 10px;
    border: 1px solid #000000;
    /* border: 1px solid #c2c6dc; */
  }
  .labels{
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 5px;
  }
  
  .show-names{
    margin-top: 5px;
    background: #ffdf48;
    color: black;
    display: inline-block;
  }
  
  </style>
  